var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusAddSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "plus-add-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.484,
    height: 24.484,
    viewBox: "0 0 24.484 24.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37855",
    "data-name": "Group 37855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37854",
    "data-name": "Group 37854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65228",
    "data-name": "Path 65228",
    d: "M12.242,0A12.242,12.242,0,1,0,24.484,12.242,12.242,12.242,0,0,0,12.242,0Zm0,23.26A11.018,11.018,0,1,1,23.26,12.242,11.018,11.018,0,0,1,12.242,23.26Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_37857",
    "data-name": "Group 37857",
    transform: "translate(5.509 5.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_37856",
    "data-name": "Group 37856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65229",
    "data-name": "Path 65229",
    d: "M128.054,121.321h-5.509v-5.509a.612.612,0,0,0-1.224,0v5.509h-5.509a.612.612,0,0,0,0,1.224h5.509v5.509a.612.612,0,0,0,1.224,0v-5.509h5.509a.612.612,0,1,0,0-1.224Z",
    transform: "translate(-115.2 -115.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusAddSvgrepoCom);
export default __webpack_public_path__ + "static/media/plus-add-svgrepo-com.3d6a3a0601a18cee45cbd0828c8cf613.svg";
export { ForwardRef as ReactComponent };